import { ref, reactive, computed, watch, onBeforeMount } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-43398214"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "search_wrap"
};
import MultipleProductSelectComp from '@/components/CustomMultipleProductSelect.vue';
import MultiSelect from '@/components/MultiSelect/index.vue';
import useGetSelect from '@/hooks/useGetSelect';
import { searchFields } from '@/common';
// import { ProductSelect } from '@dbt/product-select'
import { MarketTypeEnum } from '../hooks/useMarketList';
import '@dbt/product-select/dist/style.css';
export default /*#__PURE__*/_defineComponent({
  __name: 'SearchBlock',
  props: ['studioList', 'accountList', 'companyList', 'pubStatusList', 'subscriptionStatusData', 'payChannelList', 'choosedMarket'],
  emits: ['search', 'changeAccount'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      dbtProducts,
      getDbtProducts
    } = useGetSelect(); // 接口数据源相关一系列内容
    const accountTypeList = ref([3, 2]);
    const accountListSearch = ref([]);
    const filterOptions = reactive({
      dbtIdList: [],
      studios: [],
      payChnls: [],
      includeSubscriptionFunctions: [],
      accounts: [],
      mchs: []
    });
    // 显示的账号列表【根据选择的谷歌和ios显示不同的账号列表】
    const accountListComputed = computed(() => {
      if (accountTypeList.value.length === 1 && accountTypeList.value.includes(3)) {
        return accountListSearch.value.filter(item => item.channelType === '谷歌');
      } else if (accountTypeList.value.length === 1 && accountTypeList.value.includes(2)) {
        return accountListSearch.value.filter(item => item.channelType === '苹果');
      }
      return accountListSearch.value;
    });
    // 是否显示主体查询框
    const showCompany = computed(() => {
      return [MarketTypeEnum.ALL, MarketTypeEnum.ANDROID, MarketTypeEnum.MINIGAME].includes(props.choosedMarket);
    });
    // 是否显示账号查询框
    const showAccount = computed(() => {
      return [MarketTypeEnum.ALL, MarketTypeEnum.IOS, MarketTypeEnum.GOOGLE].includes(props.choosedMarket);
    });
    const changeProduct = () => {
      onSearch();
    };
    const changeAccountType = () => {
      filterOptions.accounts = [];
    };
    const onclear = () => {
      filterOptions.dbtIdList = [];
      filterOptions.studios = [];
      filterOptions.payChnls = [];
      filterOptions.includeSubscriptionFunctions = [];
      filterOptions.accounts = [];
      filterOptions.mchs = [];
      onSearch();
    };
    const onSearch = () => {
      var _filterOptions$accoun, _filterOptions$mchs;
      const options = {
        ...filterOptions
      };
      if (showAccount.value && (_filterOptions$accoun = filterOptions.accounts) !== null && _filterOptions$accoun !== void 0 && _filterOptions$accoun.length) {
        options.accounts = filterOptions.accounts;
        options.mchs = [];
      }
      if (showCompany.value && (_filterOptions$mchs = filterOptions.mchs) !== null && _filterOptions$mchs !== void 0 && _filterOptions$mchs.length) {
        options.mchs = filterOptions.mchs;
        options.accounts = [];
      }
      emit('search', options);
    };
    watch(() => props.accountList, val => {
      if (val !== null && val !== void 0 && val.length) {
        accountListSearch.value = val.map(item => ({
          ...item,
          label: item.label,
          value: item.value
        }));
      }
    }, {
      immediate: true
    });
    onBeforeMount(() => {
      getDbtProducts();
    });
    return (_ctx, _cache) => {
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_checkbox = _resolveComponent("a-checkbox");
      const _component_a_checkbox_group = _resolveComponent("a-checkbox-group");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_form = _resolveComponent("a-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_form, {
        layout: "horizontal",
        model: filterOptions,
        class: "form_wrap"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [_createVNode(MultipleProductSelectComp, {
            style: {
              "width": "210px"
            },
            width: "210px",
            value: filterOptions.dbtIdList,
            "onUpdate:value": _cache[0] || (_cache[0] = $event => filterOptions.dbtIdList = $event),
            productList: _unref(dbtProducts),
            showCollect: true,
            showFooter: true,
            "search-fields": _unref(searchFields),
            allowClear: true,
            placeholder: "产品查询",
            onOnConfirm: changeProduct
          }, null, 8, ["value", "productList", "search-fields"])]),
          _: 1
        }), _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            style: {
              "width": "210px"
            },
            mode: "multiple",
            allowClear: "",
            value: filterOptions.studios,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => filterOptions.studios = $event),
            placeholder: "工作室查询",
            options: __props.studioList,
            optionFilterProp: "label",
            maxTagCount: 1,
            showSearch: ""
          }, null, 8, ["value", "options"])]),
          _: 1
        }), _unref(showAccount) ? (_openBlock(), _createBlock(_component_a_form_item, {
          key: 0
        }, {
          default: _withCtx(() => [_createVNode(MultiSelect, {
            style: {
              "width": "210px"
            },
            placeholder: "账号查询",
            maxTagCount: 1,
            options: _unref(accountListComputed),
            modelValue: filterOptions.accounts,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => filterOptions.accounts = $event),
            onOk: onSearch
          }, {
            topExtra: _withCtx(() => [_createVNode(_component_a_checkbox_group, {
              value: accountTypeList.value,
              "onUpdate:value": _cache[2] || (_cache[2] = $event => accountTypeList.value = $event),
              onChange: changeAccountType
            }, {
              default: _withCtx(() => [_createVNode(_component_a_checkbox, {
                value: 3
              }, {
                default: _withCtx(() => [_createTextVNode("GP")]),
                _: 1
              }), _createVNode(_component_a_checkbox, {
                value: 2
              }, {
                default: _withCtx(() => [_createTextVNode("IOS")]),
                _: 1
              })]),
              _: 1
            }, 8, ["value"])]),
            _: 1
          }, 8, ["options", "modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), _unref(showCompany) ? (_openBlock(), _createBlock(_component_a_form_item, {
          key: 1
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            style: {
              "width": "210px"
            },
            mode: "multiple",
            allowClear: "",
            value: filterOptions.mchs,
            "onUpdate:value": _cache[4] || (_cache[4] = $event => filterOptions.mchs = $event),
            placeholder: "主体查询",
            options: __props.companyList,
            optionFilterProp: "label",
            maxTagCount: 1,
            showSearch: ""
          }, null, 8, ["value", "options"])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            style: {
              "width": "210px"
            },
            mode: "multiple",
            allowClear: "",
            value: filterOptions.includeSubscriptionFunctions,
            "onUpdate:value": _cache[5] || (_cache[5] = $event => filterOptions.includeSubscriptionFunctions = $event),
            placeholder: "是否包含订阅",
            options: __props.subscriptionStatusData,
            optionFilterProp: "label"
          }, null, 8, ["value", "options"])]),
          _: 1
        }), _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            style: {
              "width": "210px"
            },
            mode: "multiple",
            allowClear: "",
            value: filterOptions.payChnls,
            "onUpdate:value": _cache[6] || (_cache[6] = $event => filterOptions.payChnls = $event),
            placeholder: "支付渠道",
            options: __props.payChannelList,
            optionFilterProp: "label",
            maxTagCount: 1
          }, null, 8, ["value", "options"])]),
          _: 1
        }), _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_a_button, {
            class: "reset-button",
            onClick: onclear
          }, {
            default: _withCtx(() => [_createTextVNode("重置")]),
            _: 1
          }), _createVNode(_component_a_button, {
            class: "search-button",
            type: "primary",
            onClick: onSearch
          }, {
            default: _withCtx(() => [_createTextVNode("搜索")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])]);
    };
  }
});